module.exports = __webpack_public_path__ + "static/media/Thirsk-Carved-Italic-by-TTF.4c1a47fd.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Thirsk-Carved-Italic-by-TTF.ttf
// module id = 3727
// module chunks = 71